<template>
  <h1 v-bind="$attrs" v-if="level === 1 || level === '1'">
    <slot></slot>
  </h1>
  <h2 v-bind="$attrs" v-if="level === 2 || level === '2'">
    <slot></slot>
  </h2>
  <h3 v-bind="$attrs" v-if="level === 3 || level === '3'">
    <slot></slot>
  </h3>
  <h4 v-bind="$attrs" v-if="level === 4 || level === '4'">
    <slot></slot>
  </h4>
  <h5 v-bind="$attrs" v-if="level === 5 || level === '5'">
    <slot></slot>
  </h5>
  <h6 v-bind="$attrs" v-if="level === 6 || level === '6'">
    <slot></slot>
  </h6>
</template>

<script>
export default {
  props: {
    level: {
      type: [String,Number],
      default: 1,
    }
  }
};
</script>
